import React, { Component } from "react";
import { Form, Input } from "antd";
import { connect } from "react-redux";
import {
  nextStep,
  previousStep,
  uploadImage,
  hideLoader,
  showLoader,
} from "../redux/actions/miscActions";
import { saveCompDetails } from "../redux/actions/formActions";
import GradProcesBar from "./utils/GradProcesBar";

export class CompanyDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgPreview: "",
      companyLogo: "",
      companyNaam: "",
      adres: "",
      telefoonnummer: "",
      mobiel: "",
      land_stad: "",
      startDatumSalarisRonde: "",
      eindDatumSalarisRonde: "",
    };
  }

  componentDidMount = () => {
    const { companyInformation } = this.props.formData;
    this.setState({
      ...companyInformation,
    });
  };

  componentWillUnmount = () => {
    this.props.hideLoader();
  };

  handleImageSelect = (e) => {
    if (e.target.files.length === 1) {
      this.props.showLoader();
      const imgPreview = URL.createObjectURL(e.target.files[0]);
      this.props.uploadImage(e.target.files[0]);
      // this.setState({
      //   imgPreview,
      //   companyLogo: e.target.files[0],
      // });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handlePrev = () => {
    const { uploadedImage } = this.props.formData;
    const {
      imgPreview,
      companyLogo,
      companyNaam,
      adres,
      telefoonnummer,
      mobiel,
      land_stad,
      startDatumSalarisRonde,
      eindDatumSalarisRonde,
    } = this.state;

    const companyInformation = {
      imgPreview: uploadedImage,
      companyLogo: uploadedImage,
      companyNaam,
      adres,
      telefoonnummer,
      mobiel,
      land_stad,
      startDatumSalarisRonde,
      eindDatumSalarisRonde,
    };

    this.props.saveCompDetails(companyInformation);
    this.props.previousStep();
  };

  handleNext = () => {
    const { uploadedImage } = this.props.formData;
    const {
      imgPreview,
      companyLogo,
      companyNaam,
      adres,
      telefoonnummer,
      mobiel,
      land_stad,
      startDatumSalarisRonde,
      eindDatumSalarisRonde,
    } = this.state;

    const companyInformation = {
      imgPreview: uploadedImage,
      companyLogo: uploadedImage,
      companyNaam,
      adres,
      telefoonnummer,
      mobiel,
      land_stad,
      startDatumSalarisRonde,
      eindDatumSalarisRonde,
    };

    this.props.saveCompDetails(companyInformation);
    this.props.nextStep();
  };

  render() {
    const {
      imgPreview,
      companyNaam,
      adres,
      telefoonnummer,
      mobiel,
      land_stad,
      startDatumSalarisRonde,
      eindDatumSalarisRonde,
    } = this.state;
    const { isLoaderVisibile } = this.props.misc;
    const { uploadedImage } = this.props.formData;
    return (
      <div className="company-data">
        <div className="form">
          <Form layout="vertical">
            <Form.Item label="Company Logo">
              <div className="image-preview">
                <img src={uploadedImage} alt="" />
                <Input
                  type="file"
                  className="form-control-file"
                  onChange={this.handleImageSelect}
                />
                {/* <Upload onChange={this.handleImageSelect}>
                  <button>upload</button>
                </Upload> */}
              </div>
              {isLoaderVisibile ? <GradProcesBar /> : ""}
            </Form.Item>

            <Form.Item label="Company Naam">
              <Input
                name="companyNaam"
                onChange={this.handleInput}
                value={companyNaam}
              />
            </Form.Item>

            <Form.Item label="Adres">
              <Input name="adres" onChange={this.handleInput} value={adres} />
            </Form.Item>

            <Form.Item label="Land / Stad">
              <Input
                name="land_stad"
                onChange={this.handleInput}
                value={land_stad}
              />
            </Form.Item>

            <Form.Item label="Telefoon nummer">
              <Input
                name="telefoonnummer"
                onChange={this.handleInput}
                value={telefoonnummer}
              />
            </Form.Item>

            <Form.Item label="Mobiel nummer">
              <Input name="mobiel" onChange={this.handleInput} value={mobiel} />
            </Form.Item>

            <Form.Item label="Start datum salaris ronde">
              <Input
                name="startDatumSalarisRonde"
                onChange={this.handleInput}
                value={startDatumSalarisRonde}
              />
            </Form.Item>

            <Form.Item label="Eind datum salaris ronde">
              <Input
                name="eindDatumSalarisRonde"
                onChange={this.handleInput}
                value={eindDatumSalarisRonde}
              />
            </Form.Item>
          </Form>
        </div>
        <div className="buttons">
          <button className="prev-button" onClick={this.handlePrev}>
            <i className="fas fa-angle-left"></i> Previous
          </button>
          <button className="next-button" onClick={this.handleNext}>
            Next <i className="fas fa-angle-right"></i>{" "}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
  misc: state.misc,
});

export default connect(mapStateToProps, {
  previousStep,
  nextStep,
  saveCompDetails,
  uploadImage,
  hideLoader,
  showLoader,
})(CompanyDetails);
